import React from 'react';
import { Card } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import './Role.css';
export default function Role(_ref) {
  var role = _ref.role;
  if (_isEmpty(role)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Card.Description, {
    className: "role"
  }, role);
}